
















































import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-property-decorator";
import { DxPivotGrid, DxHeaderFilter, DxFieldChooser, DxFieldPanel, DxScrolling, DxExport } from 'devextreme-vue/pivot-grid';
import DxSelectBox from 'devextreme-vue/select-box';
import PivotGridConfigsProviders from '@/services/$pivotFieldsProvider';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';

@Component({
  components: {
    DxPivotGrid,
    DxHeaderFilter,
    DxFieldChooser,
    DxFieldPanel,
    DxScrolling,
    DxSelectBox,
    DxExport
  }
})
export default class PivotGrid extends Vue {
  @Prop({
    required: true
  })
  public entity!: string;

  @Prop({
    required: false
  })
  public filters!: any;

  @Watch('filters', {
    deep: true
  })
  public onFiltriChanged(currentValue: any, oldValue: any) {
    // topkek
  }

  @Ref('DxPivotGridComponent')
  public DxPivotGridComponent!: DxPivotGrid;

  public get fields() {
    return PivotGridConfigsProviders[this.entity];
  }

  public get dataSourceViewModes(): string[] {
    return this.fields.availableConfigs.map(i => i.displayName);
  }

  public dataSourceSelectedViewMode!: string;

  public _storeItems: any[] = [];

  public dataSourceReady = false;

  public dataSource!: PivotGridDataSource;

  constructor() {
    super();
  }

  async mounted() {
    this.fetchData();
    //this.reloadPivotDatasource();
  }

  public async fetchData(): Promise<void> {
    console.info('-> fetchData invoked!');
    this._storeItems = await Vue.$svc.entityList<any>(this.entity, this.filters);
    if (!this.dataSource) {
      const configName = this.fields.availableConfigs.find(i => i.name === this.fields.defaultConfig)!.name;
      this.dataSourceSelectedViewMode = this.fields.availableConfigs.find(i => i.name === this.fields.defaultConfig)!.displayName;
      this.dataSource = new PivotGridDataSource({
          fields: this.fields.availableConfigs.find(i => i.name === configName)!.fields,
          store: this._storeItems
      });
    }
    else {
      if (this.DxPivotGridComponent.instance) {
        this.DxPivotGridComponent.instance.option('dataSource', new PivotGridDataSource({
            fields: this.DxPivotGridComponent.instance.getDataSource().fields(),
            store: this._storeItems
        }));
        /*
        this.DxPivotGridComponent.instance.getDataSource().reload();
        */
      }
    }
    this.dataSourceReady = true;
  }

  public onDatasourceSelectedViewModeChange(evt: any) {
      this.reloadPivotDatasource(evt.value);
  }

  private reloadPivotDatasource(configDisplayName: string) {
    const _fields = this.fields.availableConfigs.find(i => i.displayName === configDisplayName)!.fields as any;
    if (this.DxPivotGridComponent.instance) {
      this.DxPivotGridComponent.instance.getDataSource().fields(_fields);
      this.DxPivotGridComponent.instance.getDataSource().reload();
    }
  }
}
